import React from 'react';
import List from '../components/NewList'

const CompletedProcess = () => <List bidding_process_stage="COMPLETED_PROCESS" />

export default CompletedProcess;